import React, {createContext, ReactNode, useState, Dispatch, SetStateAction, useContext, useEffect} from 'react';
import { getSeparationsStorage, setSeparationsStorage } from '../container/patioManagement/cards/separations/SeparationsStorage';

interface useContextInterface {
  valueCd: string;
  setValueCd: Dispatch<SetStateAction<string>>;
  setSeparations(valueCd: string): void;
}

interface ManagementComponent {
  children: ReactNode;
}

const ManagementContext = createContext<useContextInterface>({} as useContextInterface);

export default function ManagementProvider ({children}: ManagementComponent) {

  const [valueCd, setValueCd] = useState<string>(getSeparationsStorage().valueCd);
  const setSeparations = () => {
    setSeparationsStorage({valueCd: valueCd})
  }

  useEffect(() => {
    setSeparations()
  }, [valueCd]);

  return (
    <ManagementContext.Provider value={{valueCd, setValueCd, setSeparations}}>
      {children}
    </ManagementContext.Provider>
  )
}

export function useManagement () {
  const context = useContext<useContextInterface>(ManagementContext);
  if (!context) throw new Error("useManagement must be used within a ManagementProvider")
  const {valueCd, setValueCd, setSeparations} = context;
  return {valueCd, setValueCd, setSeparations}
}